import { useMemo } from 'react';
import useCampaigns from '../useCampaigns';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import { CampaignTableRow } from '../CampaignsTable/types';

export function useYoutubeCampaigns() {
    const { getCurrencyById } = useCurrencies();
    const {
        campaigns,
        campaignStatsData,
        projectsData,
        brandsData,
        teamsData,
        isCampaignsLoading,
        isCampaignsError,
        isProjectsLoading,
        isTeamsLoading,
        isBrandLoading,
        isCampaignStatsLoading,
    } = useCampaigns('youtube');

    const rows = useMemo(
        () =>
            campaigns.map<CampaignTableRow>((c) => {
                const stats = campaignStatsData[c.id]?.data ?? null;
                const project = projectsData.get(c.project_id) ?? null;
                const brand = project ? brandsData[project.brand_id]?.data ?? null : null;
                const team = project ? teamsData.get(project.team_id) ?? null : null;
                const currency = getCurrencyById(c.currency_id);
                return { ...c, project, brand, team, stats, currency };
            }),
        [brandsData, campaignStatsData, campaigns, projectsData, teamsData, getCurrencyById]
    );

    return {
        rows,
        isCampaignsLoading,
        isCampaignsError,
        isProjectsLoading,
        isTeamsLoading,
        isBrandLoading,
        isCampaignStatsLoading,
    };
}
